import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9447794e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page" }
const _hoisted_2 = { class: "header ws_mb16" }
const _hoisted_3 = { class: "package" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "info ws_ml10" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "ws_ml4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 认证信息 ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 资源详情 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 订单记录 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, " 设备列表 ", -1))

import { ref } from 'vue'
import { queryTenantInfo, queryTenantResource } from '@/api'
import { CODE_ENUM } from '@/common'
import { useRoute } from 'vue-router'
import BaseInfo from './components/base-info.vue'
import Resource from './components/resource.vue'
import OrderList from './components/order-list.vue'
import DeviceList from './components/device-list.vue'

import Text from '@/components/text'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

const $route = useRoute()

const orgId = $route.query.orgId

const info: any = ref([
  {
    label: '客户姓名',
    value: '',
    key: 'orgName',
  },
  {
    label: '联系人',
    value: '',
    key: 'orgContact',
  },
  {
    label: '联系人电话',
    value: '',
    key: 'orgMobile',
  },
  {
    label: '销售人员',
    value: '',
    key: 'salePerson',
  },
  {
    label: '地址',
    value: '',
    key: 'address',
  },
])

const detailData: any = ref({})
const detailLoading = ref(false)
const queryDetail = async () => {
  const res: any = await queryTenantInfo({
    orgId,
  })
  detailLoading.value = false
  if (res?.code === CODE_ENUM.SUCCESS) {
    const data = res.data
    info.value = info.value.map((item: any) => {
      return {
        ...item,
        value: data[item.key] || ' - ',
      }
    })
    detailData.value = data
  }
}

queryDetail()

const activeName = ref('info')

const formatTime = (exprieTime: any) => {
  return exprieTime === -1
    ? '无期限'
    : moment(exprieTime).format('YYYY-MM-DD') + ' 到期'
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Text), {
          content: detailData.value.packageName,
          class: "name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(detailData.value.packageName), 1)
          ]),
          _: 1
        }, 8, ["content"]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(formatTime(detailData.value.packageExpireTime)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value, (item, index) => {
          return (_openBlock(), _createElementBlock("p", { key: index }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1),
            _createTextVNode(": "),
            _createElementVNode("span", _hoisted_7, _toDisplayString(item.value), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_tabs, {
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
      class: "tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { name: "info" }, {
          label: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _createVNode(BaseInfo)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "resource" }, {
          label: _withCtx(() => [
            _hoisted_9
          ]),
          default: _withCtx(() => [
            _createVNode(Resource)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "oderList" }, {
          label: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx(() => [
            _createVNode(OrderList)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, { name: "deviceList" }, {
          label: _withCtx(() => [
            _hoisted_11
          ]),
          default: _withCtx(() => [
            _createVNode(DeviceList)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})